<template>
  <div>
    <div
      class="mb-3 d-md-flex align-items-md-center justify-content-md-between"
    >
      <div data-toggle="buttons" class="d-flex flex-wrap">
        <BDXStatusModalFiltersButton
          v-for="{ key, text, value } in buttonFields"
          :key="text"
          :value="filters[key]"
          :native-value="value"
          @input="(newFilter) => onFilter(key, newFilter)"
          >{{ text }}</BDXStatusModalFiltersButton
        >
      </div>

      <BDXStatusModalDownloadButton class="ml-auto" />

      <BaseSearchInput
        v-model="filters.search"
        placeholder="Search column"
        size="sm"
        class="my-2"
      />
    </div>

    <div class="mx-n2 d-lg-flex align-items-lg-center">
      <BDXStatusModalFiltersDropdown
        v-for="{ key, label, options } in dropdownFields"
        v-model="filters[key]"
        :key="key"
        :label="label"
        :options="options"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from '@vue/composition-api'
import { isUndefined } from 'lodash-es'

import { useCurrentUser } from '@composables'

import { BaseSearchInput } from '@components/base'

import BDXStatusModalFiltersButton from './BDXStatusModalFiltersButton.vue'
import BDXStatusModalFiltersDropdown from './BDXStatusModalFiltersDropdown.vue'
import BDXStatusModalDownloadButton from './BDXStatusModalDownloadButton.vue'

export default defineComponent({
  name: 'BDXStatusModalFilters',
  components: {
    BaseSearchInput,

    BDXStatusModalFiltersButton,
    BDXStatusModalFiltersDropdown,
    BDXStatusModalDownloadButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { hasFCPAccess } = useCurrentUser()

    const buttonFields = computed(() =>
      [
        { key: 'bdx_status', text: 'Active', value: 'Active' },
        { key: 'bdx_status', text: 'Inactive', value: 'Inactive' },
        { key: 'fcp_status', text: 'FCP', value: 'Active' },
        { key: 'bdx_status', text: 'All', value: 'All' }
      ].filter(({ key }) => {
        if (!hasFCPAccess.value) return 'fcp_status' !== key

        return true
      })
    )

    const dropdownFields = computed(() =>
      [
        {
          key: 'bdx_status',
          label: 'UMR',
          options: ['Active', 'Inactive', 'All']
        },
        {
          key: 'fcp_status',
          label: 'FCP',
          options: [
            { text: 'On', value: 'Active' },
            { text: 'Off', value: 'Inactive' },
            { text: 'All', value: 'All' }
          ]
        },
        {
          key: 'reserve',
          label: 'Reserve',
          options: [
            { text: 'Yes', value: 'True' },
            { text: 'No', value: 'False' },
            { text: 'All', value: 'All' }
          ]
        },
        {
          key: 'claim_status',
          label: 'Claim Status',
          options: [
            { text: 'Open', value: 'True' },
            { text: 'Closed', value: 'False' },
            { text: 'All', value: 'All' }
          ]
        }
      ].filter(({ key }) => {
        if (!hasFCPAccess.value) return 'fcp_status' !== key

        return true
      })
    )

    const filters = ref(props.value)

    const onFilter = (key, newFilter) => {
      const newFilters = {
        ...filters.value,
        [key]: newFilter
      }

      const { bdx_status, fcp_status } = newFilters || {}

      newFilters.fcp_status = fcp_status || 'All'

      if (isUndefined(bdx_status)) newFilters.bdx_status = 'All'

      filters.value = newFilters

      emit('input', newFilters)
    }

    return {
      buttonFields,
      dropdownFields,

      filters,
      onFilter
    }
  }
})
</script>

<style scoped>
@media (min-width: 768px) {
  div >>> .base-search-input {
    max-width: 150px;
  }
}
</style>
